const clientPurchaseFullcont        = require('./clientPurchase-fullcont')
const clientPurchaseMT              = require('./clientPurchase-fullcont-multitable')
const clientPurchasePage            = require('./clientPurchase-page')

export function start(detail){  //console.log('goku-dt 5>', detail)
         
      obj[detail.elem].start(detail)

}/**/

const obj = {
   
      fullcont:        { start: (detail)=>{  clientPurchaseFullcont. start(detail)        }},
      multitable:      { start: (detail)=>{  clientPurchaseMT.start(detail)               }},
      page:            { start: (detail)=>{  clientPurchasePage.start(detail)             }},
}